// src/views/PrivacyPolicyPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Helmet>
        <title>Privacy Policy | Spatchy</title>
        <meta name="description" content="Spatchy Privacy Policy — how we collect, use, and protect your data." />
      </Helmet>

      {/* Header */}
      <div className="border-b border-white/10 bg-slate-900/80 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
          <p className="text-slate-400 mt-2 text-sm">
            How Spatchy collects, uses, and protects your information.
          </p>
        </div>
      </div>

      {/* Termly Embed */}
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="bg-white rounded-xl overflow-hidden shadow-2xl">
          <iframe
            src="https://app.termly.io/policy-viewer/policy.html?policyUUID=ed8215ed-d673-4f0e-9298-cca952c315c8"
            title="Spatchy Privacy Policy"
            className="w-full"
            style={{ height: '80vh', minHeight: '600px', border: 'none' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;